export const QuickNavigationOption = {
  BACK: 2,
  FORWARD: 1,
  NOW: 5,
  TODAY: 3,
  WEEK_START: 4,
};

export const QuickNavigationUserOptionValue = {
  NOW: QuickNavigationOption.NOW,
  TODAY: QuickNavigationOption.TODAY,
  WEEK_START: QuickNavigationOption.WEEK_START,
};

export const QuickNavigationUserOptions = [
  { label: "Week start", value: QuickNavigationUserOptionValue.WEEK_START },
  { label: "Today", value: QuickNavigationUserOptionValue.TODAY },
  { label: "Now", value: QuickNavigationUserOptionValue.NOW },
];
